export { default } from './CopyableEntry'
